export default __webpack_public_path__ + "static/media/Farmaoffice.a342bc39.svg";